import { AnouncementDelegate } from './anouncement.delegate';
import { AuthenticationService } from '../AuthenticationService/authentication.service';
import { AnouncementService } from './anouncement.service';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { HttpProviderFactory } from '../http/http-provider.factory';
import { IAppConfig } from '../http/types/IApplicationConfig';

export class AnouncementServiceFactory
{
    static create(config: IAppConfig,
        spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService): AnouncementService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new AnouncementDelegate(httpProvider);
        return new AnouncementService(delegate, authenticationService);
    }
}